import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function Offer() {
  return <section className="py-24 px-4 bg-[#f5f0e8]" data-id="element-60">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-61">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-[#1e2a38]/10" data-id="element-62">
          <h2 className="text-3xl md:text-4xl font-serif text-[#1e2a38] mb-4" data-id="element-63">
            The 3AM Wake-Up Reset
          </h2>
          <p className="text-xl text-[#c9a07a] font-medium mb-8 uppercase tracking-widest" data-id="element-64">
            Menopause Edition
          </p>

          <div className="flex items-center justify-center gap-2 mb-8" data-id="element-65">
            <span className="text-5xl font-bold text-[#1e2a38]" data-id="element-66">$17</span>
            <span className="text-gray-500 line-through text-xl" data-id="element-67">$47</span>
          </div>

          <div className="space-y-4" data-id="element-68">
            <Button variant="primary" fullWidth className="text-xl py-6" data-id="element-69">
              Yes — I want the 3AM Reset
            </Button>
            <Button variant="outline" fullWidth className="text-lg" data-id="element-70">
              Download the Bedside Card + 7-Night Plan
            </Button>
          </div>

          <div className="mt-8 pt-8 border-t border-gray-100" data-id="element-71">
            <div className="flex items-center justify-center gap-2 text-gray-600 mb-4" data-id="element-72">
              <ShieldCheck className="w-5 h-5 text-[#c9a07a]" data-id="element-73" />
              <span className="font-medium" data-id="element-74">Consumer-Safe Guarantee</span>
            </div>
            <p className="text-sm text-gray-500" data-id="element-75">
              If you read it and feel it's not for you, you can keep the tracker
              and decision card and move on. No drama.
            </p>
          </div>
        </div>

        <div className="pt-12" data-id="element-76">
          <h3 className="text-2xl font-serif text-[#1e2a38] mb-6" data-id="element-77">
            You don't need perfect sleep to get your life back.
          </h3>
          <p className="text-lg text-gray-700 mb-8" data-id="element-78">
            You need to stop making 3AM mean{' '}
            <span className="italic" data-id="element-79">"Here we go again"</span> and start making
            it mean{' '}
            <span className="font-bold text-[#1e2a38]" data-id="element-80">
              "I know what to do next."
            </span>
          </p>
        </div>
      </div>
    </section>;
}